import { b as baseTokens } from './output/ts/base-BusbZM5v-BusbZM5v.js';
import { l as lightThemeTokens } from './output/ts/light-DG7YnQyr-DG7YnQyr.js';
import { d as darkThemeTokens } from './output/ts/dark-nbb1Askc-nbb1Askc.js';
import { d as deepMerge } from '../../../storm-ui-utils/dist/esm/deepMerge-DnBOZDdk-CPJEa3wD.js';

/**
 * Utility type for deeply merging two types together. Significantly commented because
 * this is some dark magic.
 */

const enhancedBaseTokens = {
  ...baseTokens,
  version: 4,
  color: {
    ...baseTokens.color,
    // TODO: remove in v5
    clementine: {
      ...baseTokens.color.orange
    }
  }
};
/**
 * The Storm default light theme (includes both base tokens and light theme tokens).
 */
const stormLightTheme = deepMerge(lightThemeTokens, enhancedBaseTokens);

/**
 * The Storm default dark theme (includes both base tokens and dark theme tokens).
 */
const stormDarkTheme = deepMerge(darkThemeTokens, enhancedBaseTokens);

export { stormDarkTheme as a, stormLightTheme as s };
//# sourceMappingURL=index-dYroKjHZ.js.map
